import { createListenerMiddleware } from '@reduxjs/toolkit';
import { updateChannel } from './actionCreators';
import { AppDispatch, RootState } from '@/store';
import { selectChannel } from './selectors';

export const channelListenerMiddleware = createListenerMiddleware();

const startListening = channelListenerMiddleware.startListening.withTypes<RootState, AppDispatch>();

startListening({
  actionCreator: updateChannel.fulfilled,
  effect: async (action, listenerApi) => {
    const activeChannel = selectChannel(listenerApi.getState());

    if (activeChannel?.id === action.payload.id) {
      localStorage.setItem('channel', JSON.stringify(action.payload));
    }
  },
});
